import { Service } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

const PRELOAD_DELAY_MS = 2000;

@Service()
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload']) {
      return timer(PRELOAD_DELAY_MS).pipe(switchMap(() => load()));
    }
    return of(null);
  }
}
